module.exports = __webpack_public_path__ + "img/cart-dash-fill.efd4ede5.svg";